import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/useAuthStore';
import type { ReactNode } from 'react';
import type { AdminRole } from '@/types/admin';
import { ROUTES } from '@/config/constants';

interface RoleProtectedRouteProps {
  children: ReactNode;
  requiredRole: AdminRole;
}

/**
 * 角色权限保护路由
 * 只有拥有指定角色的用户才能访问
 */
export function RoleProtectedRoute({ children, requiredRole }: RoleProtectedRouteProps) {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  // 未登录，重定向到登录页
  if (!token) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // 已登录但角色不符，重定向到首页
  if (user?.role !== requiredRole) {
    console.warn(`Access denied: User role "${user?.role}" does not have permission to access this page. Required role: "${requiredRole}"`);
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
